// extracted by mini-css-extract-plugin
module.exports = {"input":"DateInput_input__2NVf7","no-margin":"DateInput_no-margin__1nSZ2","icon":"DateInput_icon__273xN","datepicker":"DateInput_datepicker__qRcbw"};